export const DDC_FORM_SLIDECHANGE = 'ddc.form.slideChange';

function slideChange({ target } = {}, { handle, values } = {}) {
	const element = handle || target;
	// const {
	// 	handle: target = e.target,
	// 	values
	// } = ui;
	const label = $(element)
		.closest('.ui-slider')
		.siblings('input')
		.attr('name');

	const eventObject = {
		eventType: DDC_FORM_SLIDECHANGE,
		eventData: {
			element,
			label,
			values
		}
	};

	return eventObject;
}

export default slideChange;
